module.exports = __webpack_public_path__ + "img/region.a01f8454.svg";